import type { UseIntl } from '../../../../types';
import { LETTER_REGEX, NUMBER_REGEX, MIN_PASSWORD_LENGTH } from '../constants';
import messages from '../messages';

/**
 * It validates the password field value
 */
export const validatePassword = (intl: UseIntl, value?: string): string => {
  if (!value) {
    return intl.formatMessage(messages.validationPasswordRequiredError);
  }

  if (value.length < MIN_PASSWORD_LENGTH) {
    return intl.formatMessage(messages.validationPasswordTooShortError);
  }

  if (!LETTER_REGEX.test(value)) {
    return intl.formatMessage(messages.validationPasswordNoLetterError);
  }

  if (!NUMBER_REGEX.test(value)) {
    return intl.formatMessage(messages.validationPasswordNoNumberError);
  }

  return '';
};

/**
 * It validates the confirm password field value
 */
export const validateConfirmPassword = (intl: UseIntl, value1?: string, value2?: string): string => {
  if (value2 !== undefined && value1 !== value2) {
    return intl.formatMessage(messages.validationPasswordNotMatchError);
  }

  return '';
};
